<template>
  <div class="column content-box no-padding">
    <div class="row">
      <div class="small-12">
        <iframe
          title="coda"
          src="https://coda.io/embed/95ZQnlVbUS/_subnU?viewMode=embedplay%22"
          class="full-height full-width"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'iFrameDoc',
};
</script>

<style scoped>
.no-padding {
  padding: 0 !important;
}
.full-height {
  height: calc(100vh - 56px);
}

.full-width {
  width: 100%;
}
</style>
